import * as React from "react";
import { useState } from "react";
import { AuthPage as MUIAuthPage } from "@refinedev/mui";
import { SendOtpPage } from "./SendOtp";
import { VerifyOtpPage } from "./VerifyOtp";
import { Box, useTheme } from "@mui/material";

const authWrapperProps = {
  style: {
    backgroundImage: `
    /* Top Left */
    url('images/corner-flower-mandala-top-left.png'),
    /* Top Right */
    url('images/corner-flower-mandala-top-right.png'),
    /* Bottom Left */
    url('images/corner-flower-mandala-bottom-left.png'),
    /* Bottom Right */
    url('images/corner-flower-mandala-bottom-right.png'),
    /* Gradient overlay */
    radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.5) 100%)
    `,
    backgroundPosition: "left top, right top, left bottom, right bottom, center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "25% auto, 25% auto, 25% auto, 25% auto, 100% 100%",
    transform: `
    scale(1, 1),
    scale(1, 1),
    scale(1, 1),
    scale(1, 1),
    scale(1, 1)
    `,
  },
};

export const AuthPage: React.FC = () => {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <MUIAuthPage
      type="login"
      wrapperProps={{style: {
        ...authWrapperProps.style,
        backgroundColor: isDarkMode ? theme.palette.grey[900] : theme.palette.grey[50],
      }}}
      renderContent={() => (
        <Box sx={{ padding: 2 }}>
          {!sessionId ? (
            <SendOtpPage onSuccess={(session_id: string)=>setSessionId(session_id)} />
          ) : (
            <VerifyOtpPage sessionId={sessionId} onBack={()=>setSessionId(null)} />
          )}
        </Box>
      )}
    />
  );
}; 